import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function LibraryFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [searchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedItem(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedItem(null);
  };

  const categories = [
    { id: "all", name: "Todos" },
    { id: "books", name: "Livros" },
    { id: "magazines", name: "Revistas" },
    { id: "journals", name: "Periódicos" },
    { id: "thesis", name: "Teses" },
    { id: "articles", name: "Artigos" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/library?page=${pageNum}&limit=16`;
      if (category !== "all") url += `&category=${category}`;
      if (searchTerm) url += `&search=${encodeURIComponent(searchTerm)}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching library:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  if (loading && posts.length === 0) {
    return <div className="library_feed_loading"><div className="library_loader"></div><span>Carregando acervo...</span></div>;
  }

  return (
    <div className="library_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="library_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"/>
          </svg>
          <h3>Nenhum item encontrado</h3>
          <p>Seja o primeiro a adicionar ao acervo!</p>
        </div>
      ) : (
        <div className="library_grid">
          {posts.map((post) => (
            <div key={post._id} className="library_card" onClick={() => setSelectedItem(post)}>
              <div className="library_cover">
                <img src={post.libraryData?.coverImage || post.images?.[0]?.url || post.images?.[0] || "/images/default-book.png"} alt="" />
                {post.libraryData?.available !== false && (
                  <span className="library_available_badge">Disponível</span>
                )}
              </div>
              <div className="library_card_content">
                <span className="library_type">{categories.find(c => c.id === post.libraryData?.itemType)?.name || "Livro"}</span>
                <h3>{post.libraryData?.title || post.text}</h3>
                <p className="library_author">{post.libraryData?.author || "Autor desconhecido"}</p>
                {post.libraryData?.year && (
                  <span className="library_year">{post.libraryData.year}</span>
                )}
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="library_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedItem && (
        <div className="library_modal_overlay" onClick={() => setSelectedItem(null)}>
          <div className="library_modal" onClick={(e) => e.stopPropagation()}>
            <button className="library_modal_close" onClick={() => setSelectedItem(null)}>✕</button>
            <div className="library_modal_content">
              <div className="library_modal_cover">
                <img src={selectedItem.libraryData?.coverImage || selectedItem.images?.[0]} alt="" />
              </div>
              <div className="library_modal_info">
                <h2>{selectedItem.libraryData?.title}</h2>
                <p className="library_modal_author">por {selectedItem.libraryData?.author || "Autor desconhecido"}</p>
                <p className="library_modal_desc">{selectedItem.libraryData?.description || selectedItem.text}</p>
                <div className="library_modal_details">
                  {selectedItem.libraryData?.publisher && <div><strong>Editora:</strong> {selectedItem.libraryData.publisher}</div>}
                  {selectedItem.libraryData?.year && <div><strong>Ano:</strong> {selectedItem.libraryData.year}</div>}
                  {selectedItem.libraryData?.isbn && <div><strong>ISBN:</strong> {selectedItem.libraryData.isbn}</div>}
                  {selectedItem.libraryData?.pages && <div><strong>Páginas:</strong> {selectedItem.libraryData.pages}</div>}
                </div>
                <Link to={`/profile/${selectedItem.user.username}`} className="library_contributor">
                  <img src={selectedItem.user.picture} alt="" />
                  <span>Contribuído por {selectedItem.user.first_name}</span>
                </Link>
                <div className="library_modal_footer">
                  <button className="library_borrow_btn">Solicitar Empréstimo</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
